import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-l-small', 'IconLetterLSmall', [
  ['path', { d: 'M10 8v8h4', key: 'svg-0' }],
]);
